/* eslint-disable no-console */
import { getAccountData } from './consumer-account/account-api';
import { updateSwatchCartStatusMessage } from './consumer-account/account-status-helpers';

let swatchbookData;

const getItemById = (id) => {
  // console.log(`swatchbook-utils.js, getItemById, id: ${id}`);
  const item = swatchbookData.items.find(saved => saved.id === id);
  if (item !== undefined) {
    return item;
  }
  return null;
};

const getAllOfType = (type) => {
  if (!swatchbookData) {
    return [];
  }
  const arr = swatchbookData.items.filter(item => item.type === type);
  return arr;
};

const getSwatchbookData = () => {
  let data = window.ls.getItemFromObj(window.ls.cookies.swbk);
  if (data === null) {
    // Set up an empty data object
    data = { items: [], cart: [] };
  }
  return data;
};

const getUserData = (callback) => {
  getAccountData(callback);
};

const saveItem = (options) => {
  switch(options.type) {
    case 'swatch':
      break;
    case 'photo':
      options.id = window.widenUtils.getIdFromAssetUrl(options.imageUrl);
      break;
    case 'location':
      options.id = 'dealer';
      break;
  }
  if (getItemById(options.id) !== null) {
    // console.log(`${options.id} already in swatchbook.`);
    return;
  }
  // Add timestamp
  options.page = window.location.href;
  options.dateSaved = Date.now();
  swatchbookData.items.push(options);
  window.ls.setItemInObj(window.ls.cookies.swbk, swatchbookData);
  if (options.type === 'swatch') {
    updateSwatchCartStatusMessage('add');
  }
};

const removeItem = (type, val) => {
  let id;
  switch(type) {
    case 'swatch':
      id = val;
      break;
    case 'photo':
      id = window.widenUtils.getIdFromAssetUrl(val);
      break;
    case 'location':
      id = val;
      break;
    case 'visualization':
      id = val;
      break;
    default:
      break;
  }
  const at = swatchbookData.items.findIndex(saved => saved.id === id);
  if (at !== undefined) {
    // Remove item
    swatchbookData.items.splice(at, 1);
    // console.log(`${id} removed from swatchbook.`);
    // Update data object in storage
    window.ls.setItemInObj(window.ls.cookies.swbk, swatchbookData);
    if (type === 'swatch') {
      updateSwatchCartStatusMessage('remove');
    }
  }
};

const addSwatchToCart = (id) => {
  if (getSwatchbookData === null) {
    init();
  }
  if (swatchbookData.cart.indexOf(id) === -1) {
    swatchbookData.cart.push(id);
    window.ls.setItemInObj(window.ls.cookies.swbk, swatchbookData);
  }
};

const removeSwatchFromCart = (id) => {
  const at = swatchbookData.cart.findIndex(saved => saved === id);
  if (at !== -1) {
    // Remove item
    // console.log(`${id} removed from cart.`);
    swatchbookData.cart.splice(at, 1);
    // Update data object in storage
    window.ls.setItemInObj(window.ls.cookies.swbk, swatchbookData);
  }
};

const clearSwatchbook = () => {
  if (swatchbookData === null || !swatchbookData) {
    return;
  }
  swatchbookData.items = [];
  window.ls.setItemInObj(window.ls.cookies.swbk, swatchbookData);
};

const clearCart = () => {
  if (swatchbookData === null || !swatchbookData) {
    return;
  }
  swatchbookData.cart = [];
  window.ls.setItemInObj(window.ls.cookies.swbk, swatchbookData);
};

const clearOrderData = () => {
  clearCart();
  window.ls.deleteItem(window.ls.cookies.ordinfo);
};

const destroy = () => {
  swatchbookData = null;
};

const clearAllSwatchbookData = () => {
  if (swatchbookData === null || !swatchbookData) {
    return;
  }
  clearOrderData();
  clearSwatchbook();
  destroy();
};

const getSwatchProductUrlParams = (productName, callback) => {
  // console.log(productName.toLowerCase());
  // Pass product name (lc) to get visualization url params...
  const requestUrl = '/api/service/getvisualizationproperties?pagename=' + productName.toLowerCase();
  const request = new XMLHttpRequest();
  request.open('GET', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const data = JSON.parse(request.responseText);
      if (callback) {
        callback({
          visualizerModelId: data.VisualizerModelId,
          visualizerProgamFamilyName: data.VisualizerProgramFamilyName
        });
      }
    }
  };
  request.onerror = () => {
    console.log('error');
  };
  if (window.localTesting) {
    if (callback) {
      let testData = {
        visualizerModelId: null,
        visualizerProgamFamilyName: null
      };
      if (productName.indexOf('Cellular Shades') !== -1) {
        testData = {
          visualizerModelId: 'CELL',
          visualizerProgamFamilyName: 'CELL'
        };
      }
      callback(testData);
    }
    return;
  }
  request.send();
};

const getAllSelectedSwatches = () => {
  const {
    isAuthenticated,
    StorageActions,
    swatchbook,
  } = window;
  const { getItemsFromAccount } = StorageActions;
  const { getAllOfType } = swatchbook;
  const type = 'swatch';
  return new Promise((resolve) => {
    if (isAuthenticated) {
      getItemsFromAccount(type, (data) => {
        resolve(data.swatches);
      });
    } else {
      resolve(getAllOfType(type));
    }
  });
};

const init = () => {
  swatchbookData = getSwatchbookData();
};

export {
  saveItem,
  removeItem,
  addSwatchToCart,
  removeSwatchFromCart,
  getAllSelectedSwatches,
  getSwatchbookData,
  getItemById,
  getAllOfType,
  getUserData,
  clearAllSwatchbookData,
  clearCart,
  clearOrderData,
  clearSwatchbook,
  getSwatchProductUrlParams,
  init,
  destroy,
};
/* eslint-enable no-console */
